import { defineComponent as f, ref as v, inject as b, onMounted as u, watchEffect as m, onBeforeUnmount as p, provide as w, toRef as O, h as g } from "vue";
import { isImageSupportNativeLazy as S } from "./ghl-ui.es881.js";
import { imageContextKey as P, imagePreviewSharedProps as I } from "./ghl-ui.es1022.js";
import { observeIntersection as E } from "./ghl-ui.es882.js";
import { imageGroupInjectionKey as j } from "./ghl-ui.es1023.js";
import y from "./ghl-ui.es1024.js";
import L from "./ghl-ui.es854.js";
const C = Object.assign({
  alt: String,
  height: [String, Number],
  imgProps: Object,
  previewedImgProps: Object,
  lazy: Boolean,
  intersectionObserverOptions: Object,
  objectFit: {
    type: String,
    default: "fill"
  },
  previewSrc: String,
  fallbackSrc: String,
  width: [String, Number],
  src: String,
  previewDisabled: Boolean,
  loadDescription: String,
  onError: Function,
  onLoad: Function
}, I), F = f({
  name: "Image",
  props: C,
  inheritAttrs: !1,
  setup(r) {
    const n = v(null), l = v(!1), s = v(null), o = b(j, null), {
      mergedClsPrefixRef: h
    } = o || L(r), d = {
      click: () => {
        if (r.previewDisabled || l.value)
          return;
        const e = r.previewSrc || r.src;
        if (o) {
          o.setPreviewSrc(e), o.setThumbnailEl(n.value), o.toggleShow();
          return;
        }
        const {
          value: i
        } = s;
        i && (i.setPreviewSrc(e), i.setThumbnailEl(n.value), i.toggleShow());
      }
    }, a = v(!r.lazy);
    u(() => {
      var e;
      (e = n.value) === null || e === void 0 || e.setAttribute("data-group-id", (o == null ? void 0 : o.groupId) || "");
    }), u(() => {
      if (r.lazy && r.intersectionObserverOptions) {
        let e;
        const i = m(() => {
          e == null || e(), e = void 0, e = E(n.value, r.intersectionObserverOptions, a);
        });
        p(() => {
          i(), e == null || e();
        });
      }
    }), m(() => {
      var e;
      r.src || ((e = r.imgProps) === null || e === void 0 || e.src), l.value = !1;
    });
    const c = v(!1);
    return w(P, {
      previewedImgPropsRef: O(r, "previewedImgProps")
    }), Object.assign({
      mergedClsPrefix: h,
      groupId: o == null ? void 0 : o.groupId,
      previewInstRef: s,
      imageRef: n,
      showError: l,
      shouldStartLoading: a,
      loaded: c,
      mergedOnClick: (e) => {
        var i, t;
        d.click(), (t = (i = r.imgProps) === null || i === void 0 ? void 0 : i.onClick) === null || t === void 0 || t.call(i, e);
      },
      mergedOnError: (e) => {
        if (!a.value)
          return;
        l.value = !0;
        const {
          onError: i,
          imgProps: {
            onError: t
          } = {}
        } = r;
        i == null || i(e), t == null || t(e);
      },
      mergedOnLoad: (e) => {
        const {
          onLoad: i,
          imgProps: {
            onLoad: t
          } = {}
        } = r;
        i == null || i(e), t == null || t(e), c.value = !0;
      }
    }, d);
  },
  render() {
    var r, n;
    const {
      mergedClsPrefix: l,
      imgProps: s = {},
      loaded: o,
      $attrs: h,
      lazy: d
    } = this, a = (n = (r = this.$slots).placeholder) === null || n === void 0 ? void 0 : n.call(r), c = this.src || s.src, e = g("img", Object.assign(Object.assign({}, s), {
      ref: "imageRef",
      width: this.width || s.width,
      height: this.height || s.height,
      src: this.showError ? this.fallbackSrc : d && this.intersectionObserverOptions ? this.shouldStartLoading ? c : void 0 : c,
      alt: this.alt || s.alt,
      "aria-label": this.alt || s.alt,
      onClick: this.mergedOnClick,
      onError: this.mergedOnError,
      onLoad: this.mergedOnLoad,
      // If interseciton observer options is set, do not use native lazy
      loading: S && d && !this.intersectionObserverOptions ? "lazy" : "eager",
      style: [s.style || "", a && !o ? {
        height: "0",
        width: "0",
        visibility: "hidden"
      } : "", {
        objectFit: this.objectFit
      }],
      "data-error": this.showError,
      "data-preview-src": this.previewSrc || this.src
    }));
    return g("div", Object.assign({}, h, {
      role: "none",
      class: [h.class, `${l}-image`, (this.previewDisabled || this.showError) && `${l}-image--preview-disabled`]
    }), this.groupId ? e : g(y, {
      theme: this.theme,
      themeOverrides: this.themeOverrides,
      clsPrefix: l,
      ref: "previewInstRef",
      showToolbar: this.showToolbar,
      showToolbarTooltip: this.showToolbarTooltip
    }, {
      default: () => e
    }), !o && a);
  }
});
export {
  F as default,
  C as imageProps
};
